import React from 'react';
import PageLayout from '../../ui/layout/PageLayout';
import FeedGenerator from './components/FeedGenerator';
import useFeedDomain from './hooks/useFeedDomain';
import './styles.css';

function FeedPage() {
  const state = useFeedDomain();

  return (
    <PageLayout
      title="Criar com IA"
      subtitle="Geração inteligente de conteúdo"
      primary={<FeedGenerator state={state} />}
      secondary={null}
    />
  );
}

export default FeedPage;
